import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private httpWithoutInterceptors: HttpClient;

  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
  ) {
    this.httpWithoutInterceptors = new HttpClient(httpBackend);
  }

  getUIVersion(): Observable<string> {
    return this.httpWithoutInterceptors.get('commit.txt', {
      responseType: 'text',
    });
  }

  getAPIVersion(): Observable<string> {
    return this.http.get('files/commit.txt', {
      responseType: 'text',
    });
  }
}
